// extracted by mini-css-extract-plugin
export default {"section":"InputControls_section__gkyN+","container":"InputControls_container__7hcdZ","header":"InputControls_header__Fk-Dm","controlsFrame":"InputControls_controlsFrame__30ChU"};